const goalIcons = {
  stress: 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/icon_stress.svg',
  brain: 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/icon_brain.svg',
  energy: 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/icon_energy.svg',
  fitness: 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/Lifestyle_Icon_c1ae5a70-f519-4f50-b1d5-0af90a2eabe5.webp',
  bones: 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/icon_bones.svg',
  sleep: 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/icon_sleep.svg',
  hair: 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/icon_hair.svg',
  heart: 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/icon_heart.svg',
  joints: 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/icon_joints.svg',
  skin: 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/icon_skin.svg',
  digestion: 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/icon_digestion.svg',
  immunity: 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/icon_immunity.svg',
};

const chevronUpUrl = "https://cdn.shopify.com/s/files/1/0914/5070/4171/files/mdi_chevron-up.svg?v=1752549936";
const chevronDownUrl = "https://cdn.shopify.com/s/files/1/0914/5070/4171/files/mdi_chevron-down.svg?v=1752549935";
const tickIconUrl = "https://cdn.shopify.com/s/files/1/0914/5070/4171/files/tick.svg?v=1752564381";
const plusIconUrl = "https://cdn.shopify.com/s/files/1/0914/5070/4171/files/ant-design_plus-outlined.svg?v=1752564680";
const instructionIconUrl  = 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/instruction.svg?v=1752650770';
const pillIcon = 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/graphic-pill.png?v=1753281024';
const arrowIcon = 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/Arrow.svg?v=1753281581';
const recommendationMobileBanner = 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/recommendation_banner_m.jpg?v=1753328075';
const backIcon = 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/ic_twotone-chevron-left.svg?v=1754300867';
const arrowDesktopIcon = 'https://cdn.shopify.com/s/files/1/0914/5070/4171/files/Arrow_11.svg?v=1754313230';

// Normalises data.goals from the recommendation API into a clean array of
// individual lowercase goal keys, regardless of how the backend returns them.
// Handles: string, array of strings, single-element combined string, uppercase,
// leading/trailing spaces, and null/undefined.
function normalizeGoals(rawGoals) {
  if (rawGoals == null) return [];
  // Coerce to a flat comma-separated string: works for both bare strings and
  // arrays (including the single-element combined case ["IMMUNITY,ENERGY,HAIR"]).
  var joined = Array.isArray(rawGoals) ? rawGoals.join(',') : String(rawGoals);
  return joined.split(/,\s*/).map(function (g) { return g.trim().toLowerCase(); }).filter(Boolean);
}

/**
 * Syncs recommendation quiz values to localStorage if needed
 * Only updates values if user is not logged in AND (localStorage is empty OR values differ)
 * @param {Object} recommendationData - The recommendation data from backend
 * @returns {Promise} Promise that resolves when synchronization is complete
 */
function syncQuizValuesFromRecommendation(recommendationData) {
  return new Promise((resolve) => {
    // Check if user is logged in
    const isLoggedIn = window.__vitableMetafields?.loggedIn === true;
    
    // Keys for localStorage
    const PREGNANCY_KEY = 'vitable_pregnancy';
    const ALLERGY_KEY = 'vitable_allergy';
    const NAME_ON_PACK_KEY = 'vitable_name_on_pack';
    const AGE_KEY = 'vitable_age';
    
    // Extract values from recommendation
    const recoPregnancy = recommendationData?.pregnancy;
    const recoAllergy = recommendationData?.allergy;
    const recoNameOnPack = recommendationData?.name_on_pack;
    
    try {
      // Get current localStorage values
      const localPregnancy = localStorage.getItem(PREGNANCY_KEY);
      const localAllergy = localStorage.getItem(ALLERGY_KEY);
      const localNameOnPack = localStorage.getItem(NAME_ON_PACK_KEY);
    
    // Update pregnancy - MODIFIED to handle null as meaningful value
    if (recoPregnancy !== undefined && 
        (localPregnancy === null || localPregnancy !== recoPregnancy)) {
      localStorage.setItem(PREGNANCY_KEY, recoPregnancy);
      console.log('[Reco] Updated pregnancy from recommendation:', recoPregnancy);
    }
    
    // Update allergy - MODIFIED to handle null as meaningful value
    if (recoAllergy !== undefined && 
        (localAllergy === null || localAllergy !== recoAllergy)) {
      localStorage.setItem(ALLERGY_KEY, recoAllergy);
      console.log('[Reco] Updated allergy from recommendation:', recoAllergy);
    }
    
    // Update name_on_pack with hierarchical fallback for retake quiz flow
    let nameToUse = null;
    
    // 1. Primary: Use API name_on_pack or firstName if available
    const nameFromApi = recoNameOnPack || recommendationData?.firstName;
    if (nameFromApi && nameFromApi.trim() !== '') {
      nameToUse = nameFromApi;
      console.log('[Reco] Using name from API:', nameToUse);
    } 
    // 2. Secondary: For logged-in users, fallback to metafield if API is empty
    else if (isLoggedIn && window.__vitableMetafields?.name_on_pack && 
             window.__vitableMetafields.name_on_pack.trim() !== '') {
      nameToUse = window.__vitableMetafields.name_on_pack;
      console.log('[Reco] Using name from customer metafield (API empty):', nameToUse);
    }
    // 3. Tertiary: Keep existing localStorage value (do nothing)
    
    // Update localStorage only if we have a valid name to use
    if (nameToUse && (localNameOnPack === null || localNameOnPack !== nameToUse)) {
      localStorage.setItem(NAME_ON_PACK_KEY, nameToUse);
      console.log('[Reco] Updated name_on_pack in localStorage:', nameToUse);
    }
    
    // Update age
    const recoAge = recommendationData?.age;
    const localAge = localStorage.getItem(AGE_KEY);

    if (recoAge !== undefined && (localAge === null || localAge !== String(recoAge))) {
      localStorage.setItem(AGE_KEY, String(recoAge));
      console.log('[Reco] Updated age from recommendation:', recoAge);
    }

    // Store goals
    var goals = recommendationData?.goals;
    if (Array.isArray(goals) && goals.length > 0) {
      localStorage.setItem('vitable_goals', JSON.stringify(goals));
      console.log('[Reco] Stored goals:', goals);
    }
    
    // Trim helper — extract only the fields needed for data capture
    function trimProduct(product) {
      var variant = product.variants && product.variants[0];
      // Extract goal_category and for_your_reason from variant.recommendations[0].fields
      var goalCategory = '';
      var forYourReason = '';
      if (variant && Array.isArray(variant.recommendations) && variant.recommendations.length > 0) {
        var fields = variant.recommendations[0].fields;
        if (Array.isArray(fields)) {
          for (var i = 0; i < fields.length; i++) {
            if (fields[i].key === 'goal_category' && fields[i].value) {
              goalCategory = String(fields[i].value);
            }
            if (fields[i].key === 'for_your_reason' && fields[i].value) {
              forYourReason = String(fields[i].value);
            }
          }
        }
      }
      return {
        productId: String(product.id || ''),
        variantId: String(variant && variant.id || ''),
        title: product.title || '',
        handle: product.handle || '',
        goalCategory: goalCategory,
        forYourReason: forYourReason
      };
    }
    
    // Store primary recommended products
    if (Array.isArray(recommendationData?.products) && recommendationData.products.length > 0) {
      localStorage.setItem('vitable_recommended_products', JSON.stringify(recommendationData.products.map(trimProduct)));
      console.log('[Reco] Stored recommended products:', recommendationData.products.length);
    }
    
    // Store secondary recommended products (data capture only — not used visually)
    var secondary = recommendationData?.secondaryProducts;
    if (Array.isArray(secondary) && secondary.length > 0) {
      localStorage.setItem('vitable_recommended_secondary', JSON.stringify(secondary.map(trimProduct)));
      console.log('[Reco] Stored secondary products:', secondary.length);
    } else {
      localStorage.removeItem('vitable_recommended_secondary');
    }
    
    // Resolve the promise once synchronization is complete
    resolve();
  } catch (err) {
    console.error('[Reco] Error syncing quiz values from recommendation:', err);
    // Still resolve even on error to allow UI flow to continue
    resolve();
  }
  });
}

// ✅ Helper: validate if personalised bundle is fully loaded
function validateBundleLoaded() {
  const p = window.personalised || {};
  return !!(p.bundle && p.utils && p.sellingPlans && typeof p.bundle.addItem === 'function');
}

// ✅ Helper: safely reset bundle
function resetBundle() {
  const { bundle } = window.personalised;
  if (typeof bundle.reset === 'function') {
    console.debug('[Reco] Resetting bundle via .reset()');
    bundle.reset();
  } else if (typeof bundle.getItems === 'function' && typeof bundle.removeItem === 'function') {
    const currentItems = bundle.getItems();
    console.debug('[Reco] Manual reset, removing items:', currentItems.length);
    currentItems.forEach(item => {
      bundle.removeItem(item.variantId);
    });
  }
}

// ✅ Helper: process and add recommendation to bundle
async function applyRecommendationsToBundle(products) {
  if (!validateBundleLoaded()) {
    console.error('[Reco] Personalised bundle not ready');
    return;
  }

  if (!Array.isArray(products) || products.length === 0) {
    console.warn('[Reco] No valid recommendations to add');
    return;
  }

  const { bundle, sellingPlans, utils, config, updateUI } = window.personalised;
  const collectionId = config?.bundle?.RECHARGE?.COLLECTION_ID || '512297271595';

  resetBundle();

  const addedItems = [];

  for (const product of products) {
    const variant = product.variants?.[0];
    const variantRawId = variant?.id;
    const productRawId = product.id;
    const quantity = variant?.quantity || 1;

    if (!variantRawId || !productRawId || quantity <= 0) continue;

    const variantId = utils.normalizeShopifyId(variantRawId);
    const productId = utils.normalizeShopifyId(productRawId);
    
    // Get current frequency and determine correct selling plan
    const currentFrequency = bundle.getFrequency ? bundle.getFrequency() : '30';
    const sellingPlanLabel = config?.subscription?.DEFAULT_SELLING_PLAN_LABELS?.[currentFrequency] || '30_day_subscription';
    const sellingPlanId = sellingPlans?.[variantId]?.[sellingPlanLabel];

    console.debug('[Reco] Adding:', { productId, variantId, quantity, frequency: currentFrequency, sellingPlanLabel });

    bundle.addItem({ productId, variantId, collectionId, quantity, sellingPlanId });
    addedItems.push({ productId, variantId });
  }

  if (typeof updateUI === 'function') updateUI();

  const isEditMode = utils.getMode && config?.modes && utils.getMode() === config.modes.EDIT;
  if (!isEditMode && typeof utils.debouncedRefreshCartFromState === 'function') {
    await utils.debouncedRefreshCartFromState("Products added from recommendation");
  }

  // ✅ Emit event
  window.dispatchEvent(new CustomEvent('recommendation:bundleUpdated', {
    detail: { count: addedItems.length, items: addedItems }
  }));

  // ✅ Save to localStorage
  try {
    localStorage.setItem('vitable.recommendation', JSON.stringify({
      productIds: addedItems.map(i => i.productId),
      timestamp: Date.now()
    }));
  } catch (e) {
    console.warn('Could not store recommendation in localStorage:', e);
  }

  // ✅ Redirect
  const reviewTarget = isEditMode
    ? '/pages/manage-pack'
    : (window.personalised && window.personalised.abRouter
        ? window.personalised.abRouter.getReviewUrl()
        : '/pages/review-pack');
  window.location.href = reviewTarget;
}

function renderRecoMobile(products, firstName, goals) {
  const mobileLayout = document.getElementById('reco-mobile-layout');
  if (!mobileLayout || !Array.isArray(products)) return;

  mobileLayout.innerHTML = ''; // clear layout

  mobileLayout.innerHTML = `
    <div class="reco-mobile-header">
      <p>Recommendation</p>
      <h2 class="reco-greeting"><span>${firstName}</span> pack</h2>
      <p class="reco-desc">
        Your recommendation is based on your answers and our database of clinical research.
        Each product is carefully selected for you based on your unique lifestyle and nutrition goals.
      </p>
      <div class="reco-banner">
        <img src="${recommendationMobileBanner}" alt="">
      </div>

      <div class="reco-mobile-goals">
        <p class="goal-label">Your goals:</p>
        <div class="goal-list">
          ${goals.map(goal => `
            <div class="goal-icon">
              <img src="${goalIcons[goal] || goalIcons.fitness}" alt="${goal}" />
              <p>${goal.toUpperCase()}</p>
            </div>
          `).join('')}
        </div>
      </div>
    </div>
  `;

  const wrapper = document.createElement('div');
  wrapper.className = 'reco-mobile-wrapper';

  const title = document.createElement('h2');
  title.className = 'reco-mobile-title';
  title.innerText = 'Your monthly pack';

  const subtitle = document.createElement('div');
  subtitle.className = 'reco-mobile-subtitle';
  subtitle.innerText = '30-day supply of nutrients tailored for you';
  wrapper.appendChild(title);
  wrapper.appendChild(subtitle);

  const footer = document.createElement('div');
  footer.className = 'reco-mobile-footer';

  const btn = document.createElement('button');
  btn.id = 'reco-mobile-continue';
  btn.className = 'reco-btn';
  btn.innerText = 'Continue';

  btn.addEventListener('click', () => {
    applyRecommendationsToBundle(products);
  });

  footer.appendChild(btn);
  mobileLayout.appendChild(footer);

  products.forEach((product, index) => {
    const variant = product.variants?.[0];
    const firstRecommendation = variant?.recommendations[0] || {};
    const recoFields = firstRecommendation?.fields || [];
    const recoQuestions = recoFields.find(f => f.key === 'questions')?.value || [];
    let highestScoreQuestion = recoQuestions.reduce((max, q) => {
      return q.score > max.score ? q : max;
    }, recoQuestions[0]);

    if (product.is_min_cap && variant?.min_cap_title  && variant?.min_cap_description) {
      highestScoreQuestion = { title: variant.min_cap_title, description: variant.min_cap_description  };
    }

    const recoHealthClaims = product.featureBullets.map((claim) => claim.feature);
    const tags = product.tags.split(', ');
    // Define valid goals to filter tags
    const validGoals = [
      'Digestion', 'Bones', 'Joints', 'Hair', 'Skin', 'Nails', 'Stress', 'Sleep', 
      'Eyes', 'Brain', 'Energy', 'Heart', "Women's health", 'Fitness', "Men's health", 
      'Metabolism', 'Immunity', 'Prenatal'
    ];
    // Filter tags to only include those matching valid goals
    const filteredTags = tags.filter(tag => validGoals.includes(tag));
    const recoQualityIcons = product.qualityIcons.filter((item) => item.handle !== 'scientific_research' && item.handle !== 'traditionally_used');

    const item = document.createElement('div');
    item.className = 'reco-mobile-product';

    item.innerHTML = `
      <button class="reco-accordion-header">
        <span class="reco-accordion-img"><img src="${product.capsuleImage.url}" class="pill-icon" alt="${product.title}" /></span>
        <span class="reco-accordion-title">${product.title}</span>
        <span class="accordion-arrow">
          <img src="${chevronDownUrl}" alt="arrow" width="20" />
        </span>
      </button>

      <div class="reco-accordion-body">
        <p class="reco-reason">
          <strong class='reco-reason-title'>${highestScoreQuestion.title}</strong><br><br>${highestScoreQuestion.description}
        </p>

        <div class="reco-product-image">
          <img src="${product.bannerImage.url}" alt="${product.title}" />
        </div>

        <div class="reco-tags">
          ${filteredTags?.map(tag => `<span>${tag}</span>`).join(' | ') || ''}
        </div>

        <h3 class="reco-product-name">${product.title}</h3>
        <p class="reco-product-desc">${product.recoBody || ''}</p>

        <ul class="reco-benefits">
          ${recoHealthClaims.map(b => `<li><img src="${tickIconUrl}" class="tick-icon" alt="${product.title}" /> ${b}</li>`).join('')}
        </ul>

        <div class="reco-icons">
          ${recoQualityIcons.map(icon => `
            <p><img src="${icon.url}" alt="science" />${icon.label}</p>
          `).join('')}
        </div>

        <div class="reco-subaccordions">
          <details>
            <summary>Why our ${product.title} <img src="${plusIconUrl}" class="plus-icon" alt="${product.title}" /></summary>
            <p>${product.recoBody || 'Formulated with high absorption and scientific quality.'}</p>
          </details>
          <details>
            <summary>Ingredients & Allergens <img src="${plusIconUrl}" class="plus-icon" alt="${product.title}" /></summary>
            <div class="reco-ingredients-content">
              <p><strong>Daily Dose</strong><br> ${product.recoDosage}</p>
              <p><strong>Ingredients</strong><br> ${product.recoIngredients || 'Refer to product label.'}</p>
              <p><strong>Allergens</strong><br> ${product.recoAllergens || 'Refer to product label.'}</p>
            </div>
          </details>
          <details>
            <summary>Research <img src="${plusIconUrl}" class="plus-icon" alt="${product.title}" /></summary>
            <p>${product.recoBenefits}</p>
          </details>
          <details>
            <summary>Warnings <img src="${plusIconUrl}" class="plus-icon" alt="${product.title}" /></summary>
            <p>${product.recoDisclaimer || ''}</p>
          </details>
        </div>

        ${product?.labelImage?.url ? `
          <button class="reco-label-btn reco-label-link" onclick="showProductLabelModal('${product.labelImage.url}', '${product.title.replace(/'/g, "\\'")}')">
            View full product details
          </button>
        ` : ''}
      </div>
    `;

    wrapper.appendChild(item);
  });

  // Thêm section hướng dẫn sử dụng
  const instructionSection = document.createElement('div');
  instructionSection.className = 'reco-instruction-section';
  instructionSection.innerHTML = `
    <div class="reco-instruction-content">
      <img src="${instructionIconUrl}" alt="" />
      <p>TAKE DAILY WITH WATER AND FOOD</p>
    </div>
  `;
  wrapper.appendChild(instructionSection);

  mobileLayout.appendChild(wrapper);
}

function renderRecoDesktop(products, firstName, goals) {
  const desktopLayout = document.getElementById('reco-desktop-layout');
  if (!desktopLayout || !Array.isArray(products)) return;

  desktopLayout.innerHTML = ''; // clear layout

  const leftPane = document.createElement('div');
  leftPane.className = 'reco-left-pane';

  leftPane.innerHTML = `
    <div class="reco-header-text">
      <p class="reco-subtitle">Recommendation</p>
      <h2 class="reco-greeting">${firstName} pack</h2>
      <p class="reco-desc">
        Your recommendation is based on your answers and our database of clinical research.
        Each product is carefully selected for you based on your unique lifestyle and nutrition goals.
      </p>
    </div>

    <div class="reco-banner">
      <img src="${recommendationMobileBanner}" alt="Pack Image" />
    </div>

    <div class="reco-highlights">
      <p><span>${products.length} supplements a day</span> for 30 days</p>
      <ul>
        <li><img src="${tickIconUrl}" class="tick-icon" alt="" /> Plastic-free, compostable packaging</li>
        <li><img src="${tickIconUrl}" class="tick-icon" alt="" /> Premium Australian quality</li>
        <li><img src="${tickIconUrl}" class="tick-icon" alt="" /> Carefully curated for your needs</li>
      </ul>
    </div>

    <div class="reco-arrow">
      <img src="${arrowDesktopIcon}" alt="arrow" />
    </div>
  `;

  const rightPane = document.createElement('div');
  rightPane.className = 'reco-right-pane';

  const recoBtnContinue = document.createElement('div');
  recoBtnContinue.className = 'reco-desktop-reco-btn-continue';

  const btn = document.createElement('button');
  btn.id = 'reco-desktop-continue';
  btn.className = 'reco-btn';
  btn.innerText = 'Continue';

  btn.addEventListener('click', () => {
    applyRecommendationsToBundle(products);
  });

  recoBtnContinue.appendChild(btn);
  desktopLayout.appendChild(recoBtnContinue);

  const recoBtnBack = document.createElement('div');
  recoBtnBack.className = 'reco-desktop-reco-btn-back';

  const btnBack = document.createElement('button');
  btnBack.className = 'reco-btn-back';
  btnBack.innerHTML = `
    <img src="${backIcon}" alt="back" /> back
  `;

  btnBack.addEventListener('click', () => {
    window.location.href = '/pages/quiz';
  });

  recoBtnBack.appendChild(btnBack);
  desktopLayout.appendChild(recoBtnBack);

  const wrapper = document.createElement('div');
  wrapper.className = 'reco-desktop-wrapper';

  const listOfGoals = document.createElement('div');
  listOfGoals.innerHTML = `
    <div class="reco-desktop-goals">
      <p class="goal-desktop-label">Your goals:</p>
      <div class="goal-desktop-list">
        ${goals.map(goal => `
          <div class="goal-desktop-icon">
            <img src="${goalIcons[goal] || goalIcons.fitness}" alt="${goal}" />
            <p>${goal.toUpperCase()}</p>
          </div>
        `).join('')}
      </div>
    </div>
  `;

  const title = document.createElement('h2');
  title.className = 'reco-desktop-title';
  title.innerText = 'Your monthly pack';

  const subtitle = document.createElement('div');
  subtitle.className = 'reco-desktop-subtitle';
  subtitle.innerText = '30-day supply of nutrients tailored for you';
  wrapper.appendChild(listOfGoals);
  wrapper.appendChild(title);
  wrapper.appendChild(subtitle);

  products.forEach((product, index) => {
    const variant = product.variants?.[0];
    const firstRecommendation = variant?.recommendations[0] || {};
    const recoFields = firstRecommendation?.fields || [];
    const recoQuestions = recoFields.find(f => f.key === 'questions')?.value || [];
    let highestScoreQuestion = recoQuestions.reduce((max, q) => {
      return q.score > max.score ? q : max;
    }, recoQuestions[0]);

    if (product.is_min_cap && variant?.min_cap_title  && variant?.min_cap_description) {
      highestScoreQuestion = { title: variant.min_cap_title, description: variant.min_cap_description  };
    }

    const recoHealthClaims = product.featureBullets.map((claim) => claim.feature);
    const tags = product.tags.split(', ');
    // Define valid goals to filter tags
    const validGoals = [
      'Digestion', 'Bones', 'Joints', 'Hair', 'Skin', 'Nails', 'Stress', 'Sleep', 
      'Eyes', 'Brain', 'Energy', 'Heart', "Women's health", 'Fitness', "Men's health", 
      'Metabolism', 'Immunity', 'Prenatal'
    ];
    // Filter tags to only include those matching valid goals
    const filteredTags = tags.filter(tag => validGoals.includes(tag));
    const recoQualityIcons = product.qualityIcons.filter((item) => item.handle !== 'scientific_research' && item.handle !== 'traditionally_used');

    const item = document.createElement('div');
    item.className = 'reco-desktop-product';

    item.innerHTML = `
      <button class="reco-accordion-header">
        <span class="reco-accordion-img"><img src="${product.capsuleImage.url}" class="pill-icon" alt="${product.title}" /></span>
        <span class="reco-accordion-title">${product.title}</span>
        <span class="accordion-arrow">
          <img src="${chevronDownUrl}" alt="arrow" width="20" />
        </span>
      </button>

      <div class="reco-accordion-body">
        <p class="reco-reason">
          <strong class='reco-reason-title'>${highestScoreQuestion.title}</strong><br><br>${highestScoreQuestion.description}
        </p>

        <div class="reco-product-image">
          <img src="${product.bannerImage.url}" alt="${product.title}" />
        </div>

        <div class="reco-tags">
          ${filteredTags?.map(tag => `<span>${tag}</span>`).join(' | ') || ''}
        </div>

        <h3 class="reco-product-name">${product.title}</h3>
        <p class="reco-product-desc">${product.recoBody || ''}</p>

        <ul class="reco-benefits">
          ${recoHealthClaims.map(b => `<li><img src="${tickIconUrl}" class="tick-icon" alt="${product.title}" /> ${b}</li>`).join('')}
        </ul>

        <div class="reco-icons">
          ${recoQualityIcons.map(icon => `
            <p><img src="${icon.url}" alt="science" />${icon.label}</p>
          `).join('')}
        </div>

        <div class="reco-subaccordions">
          <details>
            <summary>Why our ${product.title} <img src="${plusIconUrl}" class="plus-icon" alt="${product.title}" /></summary>
            <p>${product.recoBody || 'Formulated with high absorption and scientific quality.'}</p>
          </details>
          <details>
            <summary>Ingredients & Allergens <img src="${plusIconUrl}" class="plus-icon" alt="${product.title}" /></summary>
            <div class="reco-ingredients-content">
              <p><strong>Daily Dose</strong><br> ${product.recoDosage}</p>
              <p><strong>Ingredients</strong><br> ${product.recoIngredients || 'Refer to product label.'}</p>
              <p><strong>Allergens</strong><br> ${product.recoAllergens || 'Refer to product label.'}</p>
            </div>
          </details>
          <details>
            <summary>Research <img src="${plusIconUrl}" class="plus-icon" alt="${product.title}" /></summary>
            <p>${product.recoBenefits}</p>
          </details>
          <details>
            <summary>Warnings <img src="${plusIconUrl}" class="plus-icon" alt="${product.title}" /></summary>
            <p>${product.recoDisclaimer || ''}</p>
          </details>
        </div>

        ${product?.labelImage?.url ? `
          <button class="reco-label-btn reco-label-link" onclick="showProductLabelModal('${product.labelImage.url}', '${product.title.replace(/'/g, "\\'")}')">
            View full product details
          </button>
        ` : ''}
      </div>
    `;

    wrapper.appendChild(item);
  });

  // Thêm section hướng dẫn sử dụng
  const instructionSection = document.createElement('div');
  instructionSection.className = 'reco-desktop-instruction-section';
  instructionSection.innerHTML = `
    <img src="${instructionIconUrl}" alt="" />
    <p>TAKE DAILY WITH WATER AND FOOD</p>
  `;
  wrapper.appendChild(instructionSection);
  rightPane.appendChild(wrapper);

  const layoutWrapper = document.createElement('div');
  layoutWrapper.className = 'reco-desktop-grid';
  layoutWrapper.appendChild(leftPane);
  layoutWrapper.appendChild(rightPane);

  desktopLayout.appendChild(layoutWrapper);

  // desktopLayout.appendChild(wrapper);
}

document.addEventListener("DOMContentLoaded", async function () {
  if (window.personalised?.utils?.initializeMode) {
    await window.personalised.utils.initializeMode();
    const mode = window.personalised.utils.getCurrentMode();
    console.debug(`[Reco Init] Current mode is ${mode}`);
  }

  // Detect screen width
  const isMobile = window.innerWidth <= 1024;

  // Toggle layout visibility
  const layoutDesktop = document.getElementById('reco-desktop-layout');
  const layoutMobile = document.getElementById('reco-mobile-layout');

  if (layoutDesktop && layoutMobile) {
    layoutDesktop.style.display = isMobile ? 'none' : 'flex';
    layoutMobile.classList.toggle('reco-hidden', !isMobile);
  }

  // Init bundle as usual
  if (window.personalised?.bundleManager?.init) {
    window.personalised.bundleManager.init().catch((e) => {
      console.error('[Recommendation] Error initializing bundle manager:', e);
    });
  }

  // Single flight guard for Continue button
  let recoContinueInFlight = false;

  function bindRecoContinueOnce(button, products) {
    if (!button || button.dataset.bound === '1') return;
    button.dataset.bound = '1';

    const onContinue = async (evt) => {
      // prevent parallel execution and accidental double-clicks
      if (recoContinueInFlight || button.disabled) return;
      recoContinueInFlight = true;
      button.disabled = true;
      button.classList.add('processing'); // optional: visual feedback
      button.setAttribute('aria-busy', 'true');

      try {
        await applyRecommendationsToBundle(products); // existing function
      } catch (err) {
        console.error('[Reco] Continue failed:', err);
      } finally {
        // small delay helps avoid accidental rapid re-triggers
        setTimeout(() => {
          button.disabled = false;
          button.classList.remove('processing');
          button.removeAttribute('aria-busy');
          recoContinueInFlight = false;
        }, 400);
      }
    };

    button.addEventListener('click', onContinue, { passive: true });
  }

  const homeUrl = window.__homeUrl || '/';
  const token = new URLSearchParams(window.location.search).get('r');
  const loading = document.getElementById('reco-loading');
  const disclaimer = document.getElementById('reco-disclaimer');
  const continueButton = document.getElementById('reco-continue');
  const layout = document.querySelector('.reco-layout');

  if (!token) {
    loading.style.display = 'none';
    window.location.href = homeUrl;
    return;
  }

  fetch(`https://lvi88fhcpg.execute-api.ap-southeast-2.amazonaws.com/prod/recommendation/recommendation?token=${encodeURIComponent(token)}`)
    .then(res => res.json())
    .then(data => {
      loading.classList.add('reco-hidden');

      // Normalise goals once so all render paths get a clean lowercase array.
      data.goals = normalizeGoals(data.goals);

      // 1. First sync quiz values with Promise for when done
      return syncQuizValuesFromRecommendation(data)
        .then(() => {
          // Helper to get display name from localStorage with proper formatting
          function getDisplayNameForReco() {
            try {
              if (data.firstName && data.firstName.trim() !== '') {
                return `${data.firstName.trim()}'s`;
              }
              const nameOnPack = localStorage.getItem('vitable_name_on_pack');
              if (nameOnPack && nameOnPack.trim() !== '') {
                return `${nameOnPack.trim()}'s`;
              }
              return 'Your';
            } catch (err) {
              console.warn('[Reco] Error reading name from localStorage:', err);
              return 'Your';
            }
          }

          // 2. Then render UI components
          if (!data.products?.length) {
            window.location.href = homeUrl;
            return;
          }

          const displayName = getDisplayNameForReco();
          if (isMobile) {
            renderRecoMobile(data.products, displayName, data.goals);
          } else {
            renderRecoDesktop(data.products, displayName, data.goals);
            layout.classList.remove('reco-hidden');
          }

          // 3. Only now check and show modal with the latest data
          checkAndShowDisclaimerModal(data);

          if (data.disclaimer?.length) {
            disclaimer.innerHTML = `<h4>Disclaimer</h4><ul>${data.disclaimer.map(d => `<li>${d}</li>`).join('')}</ul>`;
          }

          const contentsList = [];
          data.products.forEach(product => {
            const variant = product.variants?.[0];
            if (product.id && variant?.id && variant?.sku) {
              const parseSku = variant.sku.split('-');
              contentsList.push(`${product.id}:${variant.id}:${parseSku[parseSku.length - 1] || ''}`);
            }
          });

          if (contentsList.length > 0) {
            // continueButton.classList.remove('reco-hidden');
            bindRecoContinueOnce(continueButton, data.products);
          }
        })
        .catch(err => {
          console.error('[Reco] Error processing recommendation data:', err);
          // Still show content even if there was an error in synchronization
          if (data.products?.length) {
            // Helper to get display name from localStorage with proper formatting
            function getDisplayNameForReco() {
              try {
                if (data.firstName && data.firstName.trim() !== '') {
                  return `${data.firstName.trim()}'s`;
                }
                const nameOnPack = localStorage.getItem('vitable_name_on_pack');
                if (nameOnPack && nameOnPack.trim() !== '') {
                  return `${nameOnPack.trim()}'s`;
                }
                return 'Your';
              } catch (err) {
                console.warn('[Reco] Error reading name from localStorage:', err);
                return 'Your';
              }
            }

            const displayName = getDisplayNameForReco();
            if (isMobile) {
              renderRecoMobile(data.products, displayName, data.goals);
            } else {
              renderRecoDesktop(data.products, displayName, data.goals);
              layout.classList.remove('reco-hidden');
            }
          }
        });
    })
    .catch(err => {
      console.error('Recommendation fetch error:', err);
      loading.classList.add('reco-hidden');
      window.location.href = homeUrl;
    });
});

document.querySelectorAll('.reco-accordion-header').forEach(header => {
  header.addEventListener('click', () => {
    const body = header.nextElementSibling;
    const isOpen = body.style.display === 'block';
    document.querySelectorAll('.reco-accordion-body').forEach(b => b.style.display = 'none');
    body.style.display = isOpen ? 'none' : 'block';
  });
});

document.addEventListener('click', function (e) {
  if (e.target.closest('.reco-accordion-header')) {
    const header = e.target.closest('.reco-accordion-header');
    const body = header.nextElementSibling;
    const arrowImg = header.querySelector('.accordion-arrow img');

    const isOpen = body.style.display === 'block';

    document.querySelectorAll('.reco-accordion-body').forEach(el => el.style.display = 'none');
    document.querySelectorAll('.accordion-arrow img').forEach(img => {
      if (img) img.src = chevronDownUrl;
    });

    if (!isOpen) {
      body.style.display = 'block';
      if (arrowImg) arrowImg.src = chevronUpUrl;
    }
  }
});

function checkAndShowDisclaimerModal(recommendationData) {
  // Use localStorage values with fallback to recommendation data
  const allergy = localStorage.getItem('vitable_allergy') || recommendationData?.allergy;
  const pregnancy = localStorage.getItem('vitable_pregnancy') || recommendationData?.pregnancy;
  const modal = document.getElementById('reco-modal');
  const modalBody = document.getElementById('reco-modal-body');

  // Clear any existing event handlers to prevent duplication
  if (window._recoModalHandlers) {
    if (window._recoModalHandlers.escHandler) {
      document.removeEventListener('keydown', window._recoModalHandlers.escHandler);
    }
    if (window._recoModalHandlers.okHandler && window._recoModalHandlers.okButton) {
      window._recoModalHandlers.okButton.removeEventListener('click', window._recoModalHandlers.okHandler);
    }
    if (window._recoModalHandlers.cancelHandler && window._recoModalHandlers.cancelButton) {
      window._recoModalHandlers.cancelButton.removeEventListener('click', window._recoModalHandlers.cancelHandler);
    }
  }

  // Initialize handlers storage
  window._recoModalHandlers = {};

  if (!modal || !modalBody) return;

  // NEW CONSOLIDATED CHECK - only proceed if we have meaningful values that require warnings
  const hasRelevantAllergy = allergy && !['no', 'none'].includes(allergy.toLowerCase());
  const hasRelevantPregnancy = pregnancy && !['no', 'none'].includes(pregnancy.toLowerCase());
  
  if (!hasRelevantAllergy && !hasRelevantPregnancy) return;

  const messages = [];

  // Only show allergy warning if we already validated it's relevant
  if (hasRelevantAllergy) {
    messages.push(`
      <p>You mentioned that you are allergic to <strong>${allergy}</strong>.
      While the products recommended to you contain no added <strong>${allergy}</strong>, we can't guarantee they don't contain small traces of this allergen.
      Read each product label carefully if you consider adding other supplements to your pack.</p>
    `);
  }

  // Only show pregnancy warning if we already validated it's relevant
  if (hasRelevantPregnancy) {
    messages.push(`
      <p>You mentioned that you are <strong>${pregnancy}</strong>.
      Some vitamins and/or supplements may not be right for you. Read the label and any warnings before purchase.
      We recommend consulting your health professional before starting a vitamin and supplement routine.
      <br />Reach out to our lovely team if you consider adding other supplements to your pack, so they can check for you, at <a href="mailto:hello@vitable.com.au">hello@vitable.com.au</a></p>
    `);
  }

  // HTML for modal
  modalBody.innerHTML = `
    <div class="reco-disclaimer-modal">
      ${messages.join('')}
      <div class="reco-disclaimer-buttons">
        <button id="disclaimer-understand" class="reco-btn">I understand</button>
        <a id="disclaimer-cancel" href="/" class="">Or cancel recommendation and leave page</a>
      </div>
    </div>
  `;

  // Show modal
  modal.classList.remove('reco-hidden');

  // Also close on "I understand"
  const okBtn = document.getElementById('disclaimer-understand');
  const handleOk = () => {
    modal.classList.add('reco-hidden');
  };
  okBtn?.addEventListener('click', handleOk);
  window._recoModalHandlers.okHandler = handleOk;
  window._recoModalHandlers.okButton = okBtn;

  /**
   * Handle Cancel button click - clear all personalized data and redirect to homepage
   * This is specific to the recommendation page flow
   */
  const cancelBtn = document.getElementById('disclaimer-cancel');
  const handleCancel = () => {
    // Use centralized utility to clear all personalized data
    if (window.personalised?.storageManager?.clearAllPersonalisedData) {
      window.personalised.storageManager.clearAllPersonalisedData();
      console.info('[RecoModal] All personalised data cleared before redirect');
    } else {
      // Fallback if utility not available
      localStorage.removeItem('vitable_allergy');
      localStorage.removeItem('vitable_pregnancy');
      localStorage.removeItem('vitable_name_on_pack');
      localStorage.removeItem('vitable.recommendation');
      console.info('[RecoModal] Fallback data clearing before redirect');
    }

    // Teardown bundle if available
    if (window.personalised?.bundle?.teardown) {
      window.personalised.bundle.teardown();
      console.info('[RecoModal] Bundle state torn down before redirect');
    }

    // Redirect to homepage
    window.location.href = '/';
  };
  cancelBtn?.addEventListener('click', handleCancel);
  window._recoModalHandlers.cancelHandler = handleCancel;
  window._recoModalHandlers.cancelButton = cancelBtn;
  
  // Add ESC key handler that triggers the same cancel behavior
  const escHandler = (event) => {
    if (event.key === 'Escape' && !modal.classList.contains('reco-hidden')) {
      console.info('[RecoModal] ESC key pressed, treating as cancel');
      handleCancel();
    }
  };
  document.addEventListener('keydown', escHandler);
  window._recoModalHandlers.escHandler = escHandler;
}

function showProductLabelModal(imageUrl, productTitle) {
  const modal = document.getElementById('product-label-modal');
  const image = modal?.querySelector('.product-label-modal__image');

  if (!modal || !image || !imageUrl) return;

  image.src = imageUrl;
  image.alt = `Supplement facts for ${productTitle}`;
  modal.classList.remove('reco-hidden');
  document.body.classList.add('modal-open');

  // Close on click outside or ESC
  modal.addEventListener('click', (e) => {
    if (e.target === modal || e.target.classList.contains('product-label-modal__overlay')) {
      closeProductLabelModal();
    }
  });

  document.addEventListener('keydown', function escHandler(event) {
    if (event.key === 'Escape') {
      closeProductLabelModal();
      document.removeEventListener('keydown', escHandler);
    }
  });
}

function closeProductLabelModal() {
  const modal = document.getElementById('product-label-modal');
  if (modal) {
    modal.classList.add('reco-hidden');
    document.body.classList.remove('modal-open');
  }
}




